<script>
import Component from '~/sites/shop/pages/faq/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/nejcastejsi-dotazy',
      de: '/faq',
      en: '/faq',
      sk: '/najcastejsie-otazky',
    },
  },
}
</script>
